import { useController } from 'react-hook-form';
import InputRichText from './InputRichText';

export const InputRichTextController = (props) => {
    const { control, name, onChange, onBlur, ...rest } = props;
    const { field, fieldState } = useController({
        name,
        control,
    });

    return (
        <InputRichText
            value={field.value}
            onChange={(value) => {
                const forwardedValue = !value ? '' : value;
                onChange && onChange(forwardedValue);
                field.onChange(forwardedValue);
            }}
            onBlur={(...v) => {
                onBlur && onBlur(...v);
                field.onBlur(...v);
            }}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message}
            {...rest}
        />
    );
};
